import { FormattedDate } from "./FormattedDate.tsx";

/**
 * Shows when a game starts, in the fan's timezone. In US English the format is
 * "10/06, 7:00 PM EDT". The date always shows, even for a game today.
 */
export const GameTimestamp = ({ timestamp }: { timestamp: string }) => (
  <FormattedDate
    value={timestamp}
    month="2-digit"
    day="2-digit"
    hour="numeric"
    minute="2-digit"
    timeZoneName="short"
  />
);
